import { useMount } from 'ahooks'
import { image, cal, utils } from '@/utils'
import { ImageViewer, Image } from 'antd-mobile'
import styles from './index.module.less'
import { ProductItem } from '@/types/product'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const { imgFormatter } = image
const { moneyFormat } = cal
const { concatenateImageUrl } = utils

function OrderReturnDetailItem(props: {
  item: ProductItem
  currencySymbol: string
  isGoToDetail?: boolean
}) {
  const navigate = useNavigate()
  const { item, currencySymbol, isGoToDetail = true } = props
  const { product, returnProduct } = item
  const { skuList } = returnProduct
  const { productName, imageList, productStatus, productId, unitList } = product
  const [imageUrl, setImageUrl] = useState(imageList?.[0] || '')
  const isMultiple = (productStatus & 4) === 4

  async function initImg() {
    const url = (await imgFormatter(imageUrl, 140)) || ''
    setImageUrl(url)
  }

  useMount(() => {
    initImg()
  })

  async function previewImg() {
    if (imageList) {
      ImageViewer.Multi.show({
        images: [concatenateImageUrl(imageList?.[0])],
        defaultIndex: 0,
      })
    }
  }

  // 点击商品进入详情页
  function gotoDetail() {
    if (!isGoToDetail) return

    navigate(`/product/detail/${productId}`)
  }

  // 转化退货数量
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function getReturnQty(qty: number, unitIndex: number) {
    const unitItem = unitList[unitIndex]
    return cal.divide(qty, unitItem.unitRatio) + unitItem.unitName
  }

  // 转化基础单价
  function getBaseUnitPrice(price: number, priceUnitRatio: number) {
    return moneyFormat(cal.divide(price, priceUnitRatio))
  }

  return (
    <div
      className={`${styles['order-product-item']} ${
        isMultiple ? styles['order-product-item-multiple'] : ''
      }`}
    >
      <div className={styles['product-box']}>
        <Image
          className={styles['product-img']}
          lazy
          fit="cover"
          src={imageUrl}
          onClick={previewImg}
        />
        <div className={styles['product-info']}>
          <div className={`${styles['product-name']} ep-2`} onClick={gotoDetail}>
            {productName}
          </div>
          {!isMultiple && (
            <div>
              <div className={styles['product-price']}>
                {currencySymbol}
                {getBaseUnitPrice(returnProduct.maxPrice, returnProduct.skuList[0].priceUnitRatio)}
              </div>
              <div className={styles['product-quantity']}>
                {/* x{getReturnQty(returnProduct.unit1Quantity, returnProduct.skuList[0].unitIndex)} */}
                x{returnProduct.unit1Quantity} {unitList[0].unitName}
              </div>
            </div>
          )}
        </div>
      </div>

      {isMultiple && (
        <div>
          {!!skuList.length &&
            skuList.map((sku: any, index: number) => {
              const elementNames = [sku.productSpecElementName1 || '', sku.productSpecElementName2 || '', sku.productSpecElementName3 || ''].filter((item) => item).join('，')
              return (
                <div key={index} className={styles['element-info']}>
                  <div className={`${styles['product-name']}`}>
                    <p className="ep-2">{elementNames}</p>
                  </div>
                  <div>
                    <div className={styles['product-price']}>
                      {currencySymbol}
                      { getBaseUnitPrice(sku.price, sku.priceUnitRatio) }
                    </div>
                    <div className={styles['product-quantity']}>
                      {/* x{getReturnQty(sku.unit1Quantity, sku.unitIndex)} */}
                      x{sku.unit1Quantity} {unitList[0].unitName}
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      )}
    </div>
  )
}

export default OrderReturnDetailItem
